import {despliegueMenu} from './filters';
import iFrameResize from 'iframe-resizer';

// Listeners onClick despliegue filtros
var btnFiltrado = document.getElementById('show-btn-filter');
if(btnFiltrado){
  btnFiltrado.addEventListener('click', despliegueMenu, false);
}

var btnClose = document.getElementById('close-btn-filter');
if(btnClose){
  btnClose.addEventListener('click', despliegueMenu, false);
}

var btnViewResults = document.getElementById('view-results-btn');
if(btnViewResults){
  btnViewResults.addEventListener('click', despliegueMenu, false);
}


// Set class to body when no results found in buscar-restaurante

window.addEventListener('facetwp-loaded', ()=>{
  var noRestaurantsfound = document.getElementsByClassName('no-restaurants-found');
  var searchTemplate = document.getElementsByClassName('page-template-template-search');
  if(noRestaurantsfound.length > 0 && searchTemplate.length > 0){
    searchTemplate = searchTemplate[0];
    searchTemplate.classList.add('none-restaurants');
  }else{
    if(searchTemplate.length > 0){
      if(searchTemplate[0].classList.contains('none-restaurants')){
        searchTemplate[0].classList.remove('none-restaurants');
      }
    }
  }
});

window.addEventListener('load', () => {
  let searchBooking = document.getElementsByClassName('search-booking');

  if(searchBooking.length > 0) {
    searchBooking = searchBooking[0];
    document.addEventListener('click', (e) => {
      if (e.target.closest('.booking-trigger')) {
        e.preventDefault();
        let currentTarget = e.target.closest('.booking-trigger'),
        card = currentTarget.closest('.restaurant-card');

        card.classList.add('actual');
        card.closest('#restaurants-list').querySelectorAll('.restaurant-card').forEach(item => {
          if(!item.classList.contains('actual')){
            item.classList.remove('active');
          }
        });

        card.classList.remove('actual');
        card.classList.toggle('active');
        searchBooking.classList.add('visible');
        if(!card.classList.contains('active')){
          searchBooking.classList.remove('visible');
        }
        searchBooking.querySelector('.search-booking__title span').innerHTML = currentTarget.dataset.title;

        searchBooking.querySelector('.search-booking__iframe').innerHTML = '<script type="text/javascript" src="https://www.covermanager.com/reservation/gtmcrossdomain/'+ currentTarget.dataset.covermanagerSlug +'"></script>' + currentTarget.dataset.booking;

        if(document.getElementById('reservar')){
          setTimeout(()=>{
            const resizeIframe = () => {
              const iframe = window.parent.document.querySelector('.iframe-covermanager');
              if(iframe){
                iframe.style.height = '100%';
              }
            }

            resizeIframe();

            iFrameResize.iframeResizer({},'.iframe-covermanager')
          }, 300);
        }
      }
    });
  }
});
